module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-28.72bf467e.png";